import React from 'react'
import { CenterScreen } from '@ztechapps/webui.util'
import ReadMoreButton from '../components/read-more-button'

export const NotFound = () => {
  return (
    <CenterScreen>
      <h1>Page not found.</h1>
      <div>The page or link bookmark that you are looking for have been removed or changed.</div>
      <div className="mt-3">
        <ReadMoreButton url="/">Go back to home</ReadMoreButton>
      </div>
    </CenterScreen>
  )
}

export default NotFound
